<template>
    <div id="my-content2" class="col-md-9">
        <router-view></router-view>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyContents.vue